import apirequest from "../apiconf";

export default async function GetCardExpense(CardId) {
  const response = await apirequest({
    link: "expense/all/" + CardId,
    method: "GET",
  });
  return response;
}
